export default "__VITE_ASSET__DayQnfQL__"